import React, { Fragment, useRef, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import FocusTrap from 'focus-trap-react';
import { Box, Text, Icon, NakedButton } from 'roo-ui/components';
import { CONTACT_US, FAQS, QCOM_PRIVACY_AND_SECURITY_URL, QCOM_TERMS_OF_USE_URL } from 'config';
import { DrawerContainer, Drawer, DrawerClose, MenuButton, PhoneMenuLink } from './primitives';
import { AuthenticationDetailsPhone } from 'components/User';
import NavigationLinks from 'components/Header/HeaderPhone/NavigationLinks';
import SimplicityHeader from 'components/SimplicityHeader';
import { useDataLayer } from 'hooks/useDataLayer';
import AppLink from 'components/AppLink';

const PhoneMenu = ({ isPhoneMenuOpen, setIsPhoneMenuOpen, setIsQffMenuOpen }) => {
  const { emitInteractionEvent } = useDataLayer();
  const [animationStart, setAnimationStart] = useState(isPhoneMenuOpen);
  const isOpen = isPhoneMenuOpen;
  const drawerRef = useRef();

  useEffect(() => {
    // Give the DOM time to apply display:block to DrawerContainer before starting the animation
    setTimeout(() => {
      setAnimationStart(isPhoneMenuOpen);
    }, 100);
  }, [isPhoneMenuOpen]);

  const toggleDrawer = useCallback(() => {
    const newIsOpen = !isOpen;

    setIsQffMenuOpen(false);
    setIsPhoneMenuOpen(newIsOpen);

    emitInteractionEvent({ type: 'Mobile Menu', value: `Menu ${newIsOpen ? 'Expanded' : 'Collapsed'}` });
  }, [isOpen, setIsPhoneMenuOpen, setIsQffMenuOpen, emitInteractionEvent]);

  return (
    <Fragment>
      {!isOpen && (
        <MenuButton onClick={toggleDrawer} data-testid="menu-button">
          <Text fontSize="base">Menu</Text>
        </MenuButton>
      )}

      <FocusTrap active={animationStart} focusTrapOptions={{ initialFocus: () => drawerRef.current }}>
        <DrawerContainer isOpen={isOpen} ref={drawerRef}>
          <Drawer isOpen={animationStart}>
            <Box p={4} borderColor="white" borderBottom={1}>
              <AuthenticationDetailsPhone />
            </Box>
            <NavigationLinks setIsPhoneMenuOpen={setIsPhoneMenuOpen} setIsQffMenuOpen={setIsQffMenuOpen} />
            <PhoneMenuLink as={AppLink} to={CONTACT_US} onClick={toggleDrawer} data-testid="phone-contact-link">
              Contact
            </PhoneMenuLink>
            <PhoneMenuLink href={QCOM_PRIVACY_AND_SECURITY_URL} data-testid="phone-privacy-security-link">
              Privacy &amp; Security
            </PhoneMenuLink>
            <PhoneMenuLink href={QCOM_TERMS_OF_USE_URL} data-testid="phone-term-of-use-link">
              Terms of use
            </PhoneMenuLink>
            <PhoneMenuLink as={AppLink} to={FAQS} onClick={toggleDrawer} data-testid="phone-faqs-link">
              FAQs
            </PhoneMenuLink>
            <SimplicityHeader showMobileMenu />
          </Drawer>

          <DrawerClose isOpen={animationStart}>
            <NakedButton data-testid="close-btn-wrapper" onClick={toggleDrawer} mt={7}>
              <Icon name="close" />
            </NakedButton>
          </DrawerClose>
        </DrawerContainer>
      </FocusTrap>
    </Fragment>
  );
};

PhoneMenu.propTypes = {
  isPhoneMenuOpen: PropTypes.bool.isRequired,
  setIsPhoneMenuOpen: PropTypes.func.isRequired,
  setIsQffMenuOpen: PropTypes.func.isRequired,
};

export default PhoneMenu;
